<template>
  <div class="circle-container">
    <a-spin :spinning="loading">
      <a-tabs v-if="isManager" type="card" v-model="activeKey">
        <a-tab-pane key="circle" tab="班级圈"></a-tab-pane>
        <a-tab-pane key="statistics" tab="数据统计"></a-tab-pane>
      </a-tabs>
      <div v-show="activeKey === 'circle'">
        <div class="circle-search">
          <a-select class="width-160 m-right-20" v-model="params.klassId" placeholder="请选择班级" @change="tabChange">
            <a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>

          <span class="circle-statistics-modal" @click="showModal">数据统计</span>
        </div>
        <div class="circle-content">
          <div class="circle-box">
            <div class="circle-list" @mousewheel="scrollChange" ref="scrollContainer">
              <div ref="scrollEle">
                <div class="circle-item" v-if="curTheme">
                  <div class="circle-theme_bg" :style="getBgStyle(curTheme.background_image_url)"
                    @click="viewPhoto([curTheme], 0, 'background_image_url')">
                    <div class="circle-theme_mask">
                      <p class="circle-theme_name">#{{ curTheme.name }}</p>
                      <p class="circle-theme_des">{{ curTheme.description }}</p>
                    </div>
                  </div>
                </div>
                <a-divider v-if="![...announcementList, ...postList].length"></a-divider>
                <div v-if="[...announcementList, ...postList].length">
                  <div class="circle-item" v-for="(item, index) in [...announcementList, ...postList]" :key="item.id"
                    v-if="item.isAnnounce || !activeAnnounceList.includes(item.id)">
                    <span class="circle-item_avatar" :style="getBgStyle(item.author.avatar_url || avatar)"
                      @click="viewPhoto([item.author], 0, 'avatar_url')"></span>
                    <div class="circle-item_main">
                      <div>
                        <strong>{{ item.author.name }}</strong>
                        <span class="circle-item_notice"
                          v-if="item.announcement_info && item.announcement_info.is_active">已置顶</span>
                      </div>
                      <div class="circle-item_time">{{ item.create_time | timeFromNow("YYYY-MM-DD") }}
                      </div>
                      <div class="circle-item_content">
                        <span class="circle-item_notice_des" v-if="item.announcement_info">
                          <svg-icon iconClass="notice"></svg-icon>
                          通知：
                        </span>
                        <span class="circle-item_theme" v-for="tag in item.tags" :key="tag.id"># {{
                          tag.name
                        }}</span>
                        <span class="circle-item_post">{{ item.content }}</span>
                      </div>

                      <div class="circle-item_imgs" v-if="item.media_list.length">
                        <div v-for="media in item.media_list" :key="media.id" v-if="isVideo(media.content_type)" style="display:inline-block">
                          <video class="circle-item_video" :src="media.url" controls="controls"></video>
                        </div>
                        <div></div>
                        <div v-for="(media, i) in item.media_list" :key="media.id" v-if="!isVideo(media.content_type)" style="display:inline-block">
                          <app-image-view class="circle-item_img" :mediaInfo="media"  @click="viewPhoto(item.media_list, i)"/>
                        </div>
                      </div>

                      <div class="circle-item_see" v-if="!item.announcement_info">可见：{{ item.to_students.length ?
                        item.to_students.map(item => item.kid_name).join("、") : "全班" }}</div>

                      <div class="circle-item-operate">
                        <span class="circle-item-operate_item circle-item-read" v-if="item.announcement_info"
                          @click="item.showReader = !item.showReader">
                          <svg-icon iconClass="user" class="circle-item-operate_icon circle-item-read_icon"></svg-icon>
                          <span class="circle-item-read_content">{{
                            item.announcement_info.students_got.length
                          }}/{{ item.announcement_info.to_students.length }}</span>
                          <a-icon v-if="item.showReader" type="caret-up" />
                          <a-icon v-else type="caret-down" />
                        </span>
                        <span class="circle-item-operate_item" @click="item.showComment = !item.showComment">
                          <svg-icon iconClass="comment" class="circle-item-operate_icon"></svg-icon>评论({{
                            item.comments.length
                          }})
                        </span>
                        <a-tooltip placement="top" v-if="item.liked_by.length">
                          <template slot="title">
                            <span v-for="(user, i) in item.liked_by" :key="user.id">
                              <i v-if="i">、</i>
                              {{ user.name }}
                            </span>
                          </template>
                          <span class="circle-item-operate_item" @click="praiseHandle(item, index)">
                            <svg-icon v-if="hasPraised(item)" iconClass="praise"
                              class="circle-item-operate_icon"></svg-icon>
                            <svg-icon v-else iconClass="empty_praise" class="circle-item-operate_icon"></svg-icon>
                            点赞({{ item.liked_by.length }})
                          </span>
                        </a-tooltip>
                        <span v-else class="circle-item-operate_item" @click="praiseHandle(item, index)">
                          <svg-icon v-if="hasPraised(item)" iconClass="praise"
                            class="circle-item-operate_icon"></svg-icon>
                          <svg-icon v-else iconClass="empty_praise" class="circle-item-operate_icon"></svg-icon>
                          点赞({{ item.liked_by.length }})
                        </span>
                        <span class="circle-item-operate_item" @click="delHandle(item, index)">
                          <svg-icon iconClass="delete" class="circle-item-operate_icon"></svg-icon>删除
                        </span>
                        <span class="circle-item-operate_item" v-if="item.announcement_info"
                          @click="announcementOperation(item, index)">
                          <svg-icon iconClass="top" class="circle-item-operate_icon"></svg-icon>
                          {{ item.announcement_info.is_active ? "取消置顶" : "置顶" }}
                        </span>
                      </div>
                      <div v-if="item.showReader" class="circle-item_reader">
                        <div>
                          <span style="font-weight:bold;">未读：</span>
                          <span v-for="(userId, i) in unReadStudent(item.announcement_info)" :key="userId">
                            <i v-if="i">、</i>
                            {{ studentName(userId) }}
                          </span>
                        </div>
                        <a-divider class="m-top-10 m-bottom-10"></a-divider>
                        <div>
                          <span style="font-weight:bold;">已读：</span>
                          <span v-for="(userId, i) in item.announcement_info.students_got" :key="userId">
                            <i v-if="i">、</i>
                            {{ studentName(userId) }}
                          </span>
                        </div>
                      </div>
                      <div v-if="item.showComment">
                        <div class="circle-comment_list" v-if="item.comments.length">
                          <div class="circle-comment_item" v-for="comment in item.comments" :key="comment.id">
                            <div>
                              <span class="circle-comment_author">{{
                                comment.author.name
                              }}</span>
                              <a-icon v-if="comment.replied_to_author" class="circle-comment_icon" type="caret-right" />
                              <span class="circle-comment_author" v-if="comment.replied_to_author">{{
                                comment.replied_to_author.name
                              }}</span>
                              <span class="circle-comment_time">{{
                                comment.create_time |
                                timeFromNow("YYYY-MM-DD")
                              }}</span>
                              <span class="fr del-color circle-comment_reply m-left-10"
                                @click="delCommentHandle(comment, item, index)">删除</span>
                              <span class="fr circle-comment_reply" @click="setRepliedAuthor(comment, item)">回复</span>
                            </div>
                            <div class="circle-comment_content">{{ comment.content }}</div>
                          </div>
                        </div>
                        <div class="circle-comment_replied" v-if="item.replied_comment">
                          回复：{{ item.replied_comment.author.name }}
                          <a-icon class="circle-comment_replied_icon" type="close"
                            @click="item.replied_comment = undefined" />
                        </div>
                        <a-textarea class="width-100p m-top-10" v-model="item.commentVal" placeholder="请输入内容"
                          :auto-size="{ minRows: 2 }" style="resize: none" />
                        <div class="clearfix">
                          <a-button type="primary" class="fr m-top-10 m-bottom-10" shape="round"
                            @click="createCommentHandle(item, index)">评论</a-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a-divider v-if="!hasMore" class="circle-divider">暂无更多数据</a-divider>
                </div>
              </div>

              <a-empty v-if="![...announcementList, ...postList].length" />
            </div>
          </div>
          <div class="circle-sider">
            <a-button class="circle-publish" @click="publishHandle">
              <svg-icon iconClass="publish" class="circle-publish_icon"></svg-icon> 发布信息
            </a-button>
            <p class="circle-sider_title">
              <span>主题筛选</span>
              <a class="fr" href="javascript:;" @click="viewMoreHandle">更多主题<a-icon type="right" /></a>
            </p>
            <div class="circle-theme_item" :class="{ 'circle-theme_selected': params.tag_ids === theme.id }"
              v-for="theme in themeList" :key="theme.id" @click="themeChangeHandle(theme)">
              <img class="circle-theme_icon" :src="themeImage" alt="">
              <span>#{{ theme.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-show="activeKey === 'statistics'" class="circle-statistics">
        <a-table :columns="klassesColumns" :data-source="tableSource" :rowKey="record => record.klass_id" :pagination="false"
          bordered></a-table>
      </div>
    </a-spin>
    <app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />

    <a-modal width="1000px" :title="modalInfo.title" v-model="modalInfo.visible">
      <a-table :columns="columns" :data-source="modalInfo.tableSource" :loading="modalInfo.loading"
        :rowKey="record => record.id" :pagination="false" bordered>
      </a-table>

      <template slot="footer">
        <a-button type="primary" @click="modalInfo.visible = false">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
  
<script>
import { mapGetters } from "vuex"
import ThemeService from "@/api/themeService"
import PostService from "@/api/postService"
import StudentService from "@/api/studentService"
import CommentService from "@/api/commentService"
import AppViewImg from "@/components/AppViewImg"
import AppImageView from "@/components/AppImageView"
import avatar from "@/assets/images/avatar.png"
import { getStatisticsColumns, getKlassesStatisticsColumns } from "./constant"
import themeImage from "@/assets/images/theme.png"

export default {
  name: "klassCircle",
  components: { AppViewImg, AppImageView },
  data() {
    return {
      columns: getStatisticsColumns(),
      klassesColumns: getKlassesStatisticsColumns(),
      imageList: [],
      imageIndex: 0,
      avatar,
      themeList: [],
      announcementList: [],
      postList: [],
      studentList: [],
      params: {
        limit: 10,
        klassId: undefined,
        tag_ids: undefined,
        after_id: undefined
      },
      loading: false,
      hasMore: true,
      activeAnnounceList: [],
      curTheme: undefined,
      praiseLoading: false,
      modalInfo: {
        visible: false,
        loading: false,
        title: "数据统计",
        tableSource: []
      },
      activeKey: "circle",
      tableSource: [],
      themeImage
    }
  },

  computed: {
    ...mapGetters(["klassList", "userInfo", "schoolInfo", "isManager"]),
    hasPraised() {
      return function (post) {
        return post.liked_by.map(item => item.id).includes(this.userInfo.id)
      }
    },
    getBgStyle() {
      return function (thumbnail_url) {
        return {
          background: `#f5f5f5 url(${thumbnail_url}) no-repeat center center`,
          "background-size": "cover",
          cursor: "pointer"
        }
      }
    },

    studentName() {
      return function (userId) {
        const student = this.studentList.find(item => item.id === userId) || {}
        return student.kid_name || "--"
      }
    },

    unReadStudent() {
      return function (announcementInfo) {
        const { students_got, to_students } = announcementInfo
        return to_students.filter(item => !students_got.includes(item))
      }
    },

    isVideo() {
      return function (content_type) {
        return content_type.startsWith("video");
      }
    }
  },

  created() {
    this.getKlassList()
  },

  methods: {
    viewPhoto(source, index, type = "url") {
      if (!source[index][type] || !source[index][type].startsWith("http")) return
      this.imageList = source.filter(item => {
        let status = item[type] && item[type].startsWith("http")
        if (item.content_type) {
          status = status && !item.content_type.startsWith("video")
        }
        return status
      }).map(item => item[type])
      this.imageIndex = this.imageList.findIndex(item => item === source[index][type])
    },

    playVideoHandle() {

    },

    tabChange() {
      Object.assign(this.params, {
        tag_ids: undefined,
        after_id: undefined
      })
      this.loading = false
      this.hasMore = true
      this.curTheme = undefined
      this.postList = []
      this.getThemeList()
      this.getAnnouncementList()
      this.getPostList()
      this.getStudentList()
      this.$router.replace({
        name: "klassCircle",
        query: { klass_id: this.params.klassId }
      })
    },

    getKlassList(isForce = false) {
      this.$store.dispatch("getKlassListService", { isForce }).then(res => {
        this.params.klassId = this.$route.query.klass_id || (res[0] || {}).id
        this.tabChange()
        this.getKlassesStatisticsData()
      })
    },

    getStudentList() {
      StudentService.getStudentListService({
        klass_id: this.params.klassId
      }).then(res => {
        this.studentList = res || []
      })
    },

    getThemeList() {
      ThemeService.getThemeListService({
        klass_id: this.params.klassId
      }).then(res => {
        this.themeList = res || []
      })
    },

    themeChangeHandle(theme) {
      if (this.params.tag_ids === theme.id) {
        this.params.tag_ids = undefined
        this.curTheme = undefined
      } else {
        this.params.tag_ids = theme.id
        this.curTheme = theme
      }
      this.params.after_id = undefined
      this.hasMore = true
      this.postList = []
      this.getPostList()
      this.getAnnouncementList()
    },

    scrollChange() {
      const containerH = this.$refs.scrollContainer.offsetHeight
      const contentH = this.$refs.scrollEle.offsetHeight
      const scrollTop = this.$refs.scrollContainer.scrollTop

      if (contentH - containerH - scrollTop < 100) {
        this.getPostList()
      }
    },

    getPostService(post, showComment = false) {
      PostService.getPostService({ postId: post.id }).then(res => {
        res.showComment = showComment
        res.showReader = false
        res.commentVal = undefined
        res.replied_comment = undefined
        const index = this.postList.findIndex(item => item.id === post.id)
        this.$set(this.postList, index, res)

        if (post.announcement_info) {
          this.getAnnouncementList(post.id, showComment)
        }
      })
    },

    getPostList() {
      if (this.loading || !this.hasMore) return
      this.loading = true
      PostService.getPostListService(this.params)
        .then(res => {
          if (res.length >= this.params.limit) {
            this.params.after_id = res[res.length - 1].id
          } else {
            this.hasMore = false
          }
          this.loading = false
          res.forEach(item => {
            item.showComment = false
            item.showReader = false
            item.commentVal = undefined
            item.replied_comment = undefined
          })
          this.postList = [...this.postList, ...res]
        })
        .catch(() => {
          this.loading = false
        })
    },

    getAnnouncementList(id, showComment = false) {
      PostService.getAnnouncementListService({
        klassId: this.params.klassId
      }).then(res => {
        let announcementList = res.filter(item => item.announcement_info.is_active)
        if (this.params.tag_ids) {
          announcementList = announcementList.filter(item => item.tags.includes(this.params.tag_ids))
        }
        this.announcementList = announcementList.map(item => {
          item.isAnnounce = true
          item.showComment = item.id === id && showComment
          item.showReader = false
          item.commentVal = undefined
          item.replied_comment = undefined
          return item
        })
        this.activeAnnounceList = this.announcementList.map(item => item.id)
      })
    },

    praiseHandle(post) {
      if (this.praiseLoading) return
      this.praiseLoading = true
      if (this.hasPraised(post)) {
        this.cancelPraiseHandle(post)
        return
      }
      PostService.praisePostService({ postId: post.id })
        .then(() => {
          this.$message.success("操作成功")
          this.getPostService(post)
          this.praiseLoading = false
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
          this.praiseLoading = false
        })
    },

    cancelPraiseHandle(post) {
      PostService.cancelPraisePostService({ postId: post.id })
        .then(() => {
          this.$message.success("操作成功")
          this.getPostService(post)
          this.praiseLoading = false
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
          this.praiseLoading = false
        })
    },

    delHandle(post) {
      this.$confirm({
        title: "提示信息",
        content: "是否删除当前班级圈",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            PostService.delPostService({
              postId: post.id
            })
              .then(() => {
                const index = this.postList.findIndex(item => item.id === post.id)
                this.postList.splice(index, 1)
                if (post.isAnnounce) {
                  const announcementIndex = this.announcementList.findIndex(item => item.id === post.id)
                  this.announcementList.splice(announcementIndex, 1)
                }
                this.$message.success("操作成功")
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    announcementOperation(post) {
      this.$confirm({
        title: "通知信息",
        content: post.announcement_info.is_active ? `是否置顶当前通知` : "是否对当前通知取消置顶",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            if (post.announcement_info.is_active) {
              PostService.deactivateAnnounceService({
                postId: post.id
              })
                .then(() => {
                  this.getPostService(post)
                  this.$message.success("操作成功")
                  resolve()
                })
                .catch(() => {
                  reject()
                  this.$message.error("操作失败，请重新操作")
                })
              return
            }
            PostService.activateAnnounceService({
              postId: post.id
            })
              .then(() => {
                this.getPostService(post)
                this.$message.success("操作成功")
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    createCommentHandle(post) {
      if (!post.commentVal || !post.commentVal.trim().length) {
        this.$message.warning("评论内容不能为空")
        return
      }

      if (post.commentVal.trim().length > 500) {
        this.$message.warning("评论内容长度不能大于500")
        return
      }

      const params = {
        commented_id: post.id,
        klass_id: this.params.klassId,
        content: post.commentVal.trim()
      }
      if (post.replied_comment) {
        params.replied_to_comment_id = post.replied_comment.id
      }
      CommentService.createCommentService(params).then(() => {
        this.$message.success("操作成功")
        this.getPostService(post, true)
      })
    },

    delCommentHandle(comment, post) {
      this.$confirm({
        title: "提示信息",
        content: "确认要删除这条评论?",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            CommentService.delCommentService({
              commentId: comment.id
            })
              .then(() => {
                this.getPostService(post, true)
                this.$message.success("操作成功")
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    setRepliedAuthor(comment, post) {
      post.replied_comment = comment
    },

    publishHandle() {
      this.$router.push({
        name: "publish",
        query: { id: this.params.klassId }
      })
    },

    viewMoreHandle() {
      this.$router.push({
        name: "themeList",
        query: { klass_id: this.params.klassId }
      })
    },

    showModal() {
      const klassInfo = this.klassList.find(item => item.id === this.params.klassId)
      this.modalInfo = {
        visible: true,
        loading: true,
        title: `数据统计/${klassInfo.name}`,
        tableSource: []
      }

      this.getStatisticsData()
    },

    getStatisticsData() {
      PostService.getLatestStatsService({ school_id: this.schoolInfo.id, klass_ids: this.params.klassId }).then(res => {
        this.modalInfo.tableSource = res
        this.modalInfo.loading = false
      })
    },

    getKlassesStatisticsData() {
      PostService.getLatestStatsService({ school_id: this.schoolInfo.id, klass_ids: this.klassList.map(item => item.id).join(",") }).then(res => {
        const result = res.sort((a, b) => a.klass_id.localeCompare(b.klass_id))
        const tableSource = {}

        result.forEach(item => {
          if (!tableSource[item.klass_id]) {
            tableSource[item.klass_id] = {
              klass_id: item.klass_id,
              klass_name: item.klass.name,
              daily_teacher_count: 0,
              daily_kinsfolk_count: 0,
              daily_total_count: 0,
              weekly_teacher_count: 0,
              weekly_kinsfolk_count: 0,
              weekly_total_count: 0,
              monthly_teacher_count: 0,
              monthly_kinsfolk_count: 0,
              monthly_total_count: 0,
            }
          }


          tableSource[item.klass_id][`${item.frequency.toLowerCase()}_teacher_count`] += item.teacher_count;
          tableSource[item.klass_id][`${item.frequency.toLowerCase()}_kinsfolk_count`] += item.kinsfolk_count;
          tableSource[item.klass_id][`${item.frequency.toLowerCase()}_total_count`] += item.total_count;
        })
        this.tableSource = Object.values(tableSource);
      })
    }
  }
}
</script>
  
<style lang="less" scoped>
.circle {
  &-container {
    background: #ffffff;
    min-height: calc(100% - 65px);
    min-width: 1150px;
    margin-top: 15px;

    /deep/.ant-tabs-nav-scroll {
      background: #f0f2f5;
    }

    /deep/.ant-tabs-tab {
      border: none !important;
      margin: 0 !important;
    }

    /deep/.ant-tabs-bar {
      margin-bottom: 0;
    }
  }

  &-statistics {
    padding: 28px 28px 2px 30px;

    &-modal {
      padding: 5px 10px;
      color: #1890ff;
      cursor: pointer;
      border: 1px solid #1890ff;
      border-radius: 3px;
    }
  }

  &-search {
    padding: 28px 28px 0 30px;
  }

  &-content {
    display: flex;
    flex-flow: nowrap row;
    padding: 28px 28px 2px 30px;
  }

  &-box {
    width: 770px;
    border-right: 1px solid #d8d8d8;
    overflow-x: hidden;
  }

  &-list {
    width: 787px;
    height: calc(100vh - 250px);
    overflow-y: auto;
  }

  &-item {
    display: flex;
    flex-flow: nowrap row;
    width: 770px;
    margin-bottom: 28px;

    &_avatar {
      width: 56px;
      height: 56px;
      margin-right: 22px;
      border-radius: 50%;
      overflow: hidden;
      background-size: cover !important;
    }

    &_main {
      width: 700px;
      flex-grow: 1;
      padding: 5px 85px 0 0;
    }

    &_notice {
      float: right;
      width: 82px;
      height: 22px;
      line-height: 22px;
      border-radius: 4px;
      background: #ffb55a;
      font-size: 12px;
      color: #ffffff;
      text-align: center;

      &_des {
        color: #ea9518;
      }
    }

    &_time {
      height: 18px;
      margin: 10px 0;
      line-height: 18px;
      font-size: 12px;
      color: #bdbdbd;
    }

    &_theme {
      margin: 0 11px 0 7px;
      color: #01acfc;
    }

    &_post {
      color: #333333;
    }

    &_content {
      margin-bottom: 12px;
    }

    &_imgs {
      margin: 0 0 6px;
    }

    &_img {
      display: inline-block;
      position: relative;
      width: 190px;
      height: 156px;
      margin: 0 4px 5px 0;
      border-radius: 16px;
    }

    &_video {
      width: 288px;
      height: 162px;
      margin: 0 4px 5px 0;
    }

    &-operate {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      color: #8590a6;

      &_item {
        display: flex;
        flex-flow: nowrap row;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
      }

      &_icon {
        margin-right: 5px;
        font-size: 16px;
      }
    }

    &-read {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      width: 109px;
      height: 35px;
      border-radius: 4px;
      background: #e6f0fd;
      color: rgb(64, 158, 255);

      &_content {
        margin-right: 16px;
        color: #01acfc;
      }

      &_icon {
        margin: 13px;
        font-size: 18px;
      }
    }

    &_reader {
      margin-top: 18px;
      padding: 15px 20px;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
    }

    &_see {
      margin-bottom: 6px;
      font-size: 12px;
      color: rgba(204, 204, 204, 1);
    }

    &_video {}
  }

  &-sider {
    width: 330px;
    padding: 0 26px;

    &_title {
      margin-left: 5px;
      font-size: 14px;
      font-weight: bold;
      color: #3d3d3d;

      &::before {
        position: relative;
        top: 0px;
        display: inline-block;
        content: "";
        width: 6px;
        height: 6px;
        margin-right: 13px;
        background: #409eff;
        border-radius: 50%;
      }
    }
  }

  &-publish {
    display: flex;
    flex-flow: nowrap row;
    align-items: center;
    justify-content: center;
    width: 278px;
    height: 50px;
    margin: 0 5px 26px;
    border-radius: 4px;
    background: #409eff;
    color: #fff;
    font-size: 16px;

    &:hover {
      background: #409eff;
      color: #fff;
    }

    &_icon {
      margin-right: 12px;
      font-size: 22px;
    }
  }

  &-theme {
    &_item {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      // margin-top: 8px;
      padding: 12px;
      color: #3d3d3d;
      // border-bottom: 1px solid #E6EFF5;
      // background-color: #71A1E226;
      cursor: pointer;
    }

    &_selected {
      background-color: #71a1e226;
    }

    &_icon {
      width: 46px;
      height: 42px;
      margin: 0 10px 0 0;
      border-radius: 4px;
      // border: 1px solid #e8e8e8;
    }

    &_bg {
      width: 685px;
      height: 200px;
      background-size: 100%, 100% !important;
    }

    &_mask {
      background-color: rgba(0, 0, 0, 0.4);
      width: 100%;
      height: 100%;
    }

    &_name {
      padding: 30px 0 0 50px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
    }

    &_des {
      padding: 0 50px 0 50px;
      color: #fff;
      font-size: 14px;
    }
  }

  &-comment {
    font-size: 14px;
    line-height: 20px;
    color: #3d3d3d;

    &_list {
      margin-top: 15px;
      padding: 15px 20px 5px;
      border-radius: 4px;
      border: 1px solid #e5e5e5;
    }

    &_author {
      font-weight: bold;
    }

    &_time {
      margin-left: 12px;
      font-size: 12px;
      color: #bdbdbd;
    }

    &_reply {
      font-weight: bold;
      color: #8590a6;
      cursor: pointer;
    }

    &_content {
      margin: 5px 0 11px;
    }

    &_icon {
      color: #d8d8d8;
      margin: 0 10px 0 12px;
    }

    &_replied {
      margin-top: 15px;
      font-weight: bold;

      &_icon {
        font-size: 16px;
        float: right;
        cursor: pointer;
      }
    }
  }

  &-divider {
    color: #999999 !important;
  }
}
</style>
